export const cardHoverStyles = {
  '&:hover': {
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.2)',
    cursor: 'pointer',
    borderRadius: 4,
  },
};
